import { HeartPulse } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

// Mismo cálculo que el servidor: ~68 caracteres por línea de viñeta, máx. 9.
export const PPAA_MAX_LINES = 9;
const CHARS_PER_LINE = 68;

export const ppaaSyllabusItems = (text) =>
  String(text || "")
    .split("\n")
    .map((s) => s.replace(/^[\s•·\-*]+/, "").trim())
    .filter(Boolean);

export const ppaaSyllabusLines = (text) =>
  ppaaSyllabusItems(text).reduce(
    (acc, s) => acc + Math.max(1, Math.ceil(s.length / CHARS_PER_LINE)),
    0,
  );

export const PpaaCourseFields = ({ form, setForm, hours }) => {
  const lines = ppaaSyllabusLines(form.ppaa_syllabus);
  const tooLong = lines > PPAA_MAX_LINES;
  return (
    <div
      className="rounded-md border-2 border-rose-200 bg-rose-50/60 p-4 space-y-4"
      data-testid="ppaa-fields"
    >
      <div className="flex items-center gap-2 text-xs uppercase tracking-[0.14em] font-semibold text-rose-800">
        <HeartPulse className="h-4 w-4" />
        Primeros Auxilios · sin examen ni documentación de la comunidad
      </div>
      <div>
        <label className="block text-sm font-medium text-zinc-700 mb-2">
          En el certificado: «Curso de…»
        </label>
        <Input
          value={form.ppaa_course_name}
          onChange={(e) => setForm({ ...form, ppaa_course_name: e.target.value })}
          placeholder="Primeros Auxilios"
          maxLength={120}
          className="h-11 border-2 border-zinc-300 bg-white focus-visible:border-zinc-900 focus-visible:ring-0"
          data-testid="ppaa-course-name-input"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-zinc-700 mb-2">
          Temario * <span className="font-normal text-zinc-500">(un punto por línea)</span>
        </label>
        <Textarea
          value={form.ppaa_syllabus}
          onChange={(e) => setForm({ ...form, ppaa_syllabus: e.target.value })}
          rows={5}
          placeholder={"PAS\nRCP (adulto, niño y lactante)\nDesfibrilador externo semiautomático\nAtragantamiento y hemorragias"}
          className="border-2 border-zinc-300 bg-white focus-visible:border-zinc-900 focus-visible:ring-0"
          data-testid="ppaa-syllabus-input"
        />
        <p
          className={`mt-1 text-xs ${tooLong ? "font-semibold text-red-700" : "text-zinc-500"}`}
          data-testid="ppaa-syllabus-counter"
        >
          {tooLong
            ? `No cabe en el certificado: ${lines} líneas de ${PPAA_MAX_LINES}. Acorta o quita algún punto.`
            : `${ppaaSyllabusItems(form.ppaa_syllabus).length} punto(s) · sustituye a la lista de la plantilla.`}
        </p>
      </div>
      <p className="text-sm text-zinc-700" data-testid="ppaa-hours">
        Horas del certificado (según el horario):{" "}
        <span className="font-semibold text-zinc-950">{hours != null ? `${hours} h` : "—"}</span>
      </p>
    </div>
  );
};

export default PpaaCourseFields;
